import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";
const openTransportModalDataPush = (vehicle: Vehicle) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "transport-options",
        action: "open",
        type: "",
        value: "",
      },
      ...vehicleDataPush,
    });
  }
};

export default openTransportModalDataPush;
